document.addEventListener("DOMContentLoaded", function () {
  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');  
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, { 
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  window._observer = new ResizeObserver(entries => {
    for (const entry of entries) {
      const height = entry.contentRect.height;
      this.dispatchEvent(
        new CustomEvent('height-change', {
          detail: { height },
          bubbles: true,
        })
      );
    }
  });

  window._observer.observe(document.body);
  class YGImage extends HTMLElement {
      constructor() {
          super()
          this.init()
      }
      init() {
          // 这里放置初始化逻辑
          this.loaderImg()
      }

      get images() {
        return this.querySelectorAll('img[data-src]')
      }

      loaderImg () {
          // 这里放置自定义逻辑
          this.images.forEach((img) => {
            window.YGImageLoader.observe(img)
          })
      }
  }
  if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const { $popupTemplate, fn } = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => {});
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      typeof fn === 'function' && fn();
    }
    
    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        typeof fn === 'function' && fn();
      }
    }
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.itemClick);
      this.hoverButton = new theme.HoverButton(this);
      this.hoverButton.load();
    }
  
    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      if ($popupTemplate) {
        document.dispatchEvent(new CustomEvent("YGPopup:open", {
          bubbles: true,
          detail: {
            $popupTemplate,
            fn: () => {}
          }
        }))
      }
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  // 公共的写在上面↑↑↑↑↑↑↑↑↑↑

  // 组件的写在下面↓↓↓↓↓↓↓↓↓↓
  
  class YGSlideshow extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.initSwiper()
    }

    disconnectedCallback() {}

    initSwiper() {
      new Swiper(this, {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 6000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        pagination: {
          el: '.swiper-pagination',
        }
      })
    }
  }
  if (!window.customElements.get('yg-slideshow')) {
    window.customElements.define('yg-slideshow', YGSlideshow);
  }

  class YGReviews extends HTMLElement {
      constructor() {
          super()
      }
      connectedCallback() {
        this.initSwiper()
      }

      initSwiper() {
        // 这里放置自定义逻辑
        new Swiper(this, {
          centeredSlides: true,
          slidesPerView: 'auto',
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          autoplay: {
            delay: 6000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
          breakpoints: { 
            320: {  //当屏幕宽度大于等于320
              slidesPerView: 1,
              spaceBetween: 16
            },
            768: {  //当屏幕宽度大于等于320
              slidesPerView: 1.1,
              spaceBetween: 24
            },
            1280: {  //当屏幕宽度大于等于1280
              slidesPerView: 1.2,
              spaceBetween: 40
            }
          },
          on:{
            init: e => {
              if (e.passedParams.loop && e.slides.length < 4) {
                e.slides.forEach(slide => {
                  const clonedElement = slide.cloneNode(true);
                  e.slidesEl.appendChild(clonedElement);
                });
              }
            }
          }
        })
      }
  }
  if (!window.customElements.get('yg-reviews')) {
      window.customElements.define('yg-reviews', YGReviews)
  }
  class YGBrandList extends HTMLElement {
    constructor() {
        super()
    }
    connectedCallback() {
      this.initSwiper()
    }

    initSwiper() {
      // 这里放置自定义逻辑
      new Swiper(this, {
        initialSlide: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: { 
          320: {  //当屏幕宽度大于等于320
            slidesPerView: 1.2,
            spaceBetween: 20
          },
          768: {  //当屏幕宽度大于等于768
            slidesPerView: 2.6,
            spaceBetween: 15
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 4.2,
            spaceBetween: 24
          }
        }
      })
    }
  }
  if (!window.customElements.get('yg-brand-list')) {
      window.customElements.define('yg-brand-list', YGBrandList)
  }  

  class YGAnchor extends HTMLElement {
      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);
          this._sectionList = null;
      }

      get sectionTop(){
        // 只在第一次获取时缓存 section 列表
        if (!this._sectionList) {
          this._sectionList = document.querySelectorAll('.main-content .shopify-section');
        }
      
        const sectionIndex = parseInt(this.getAttribute('data-section'), 10) - 1;
        const $section = this._sectionList[sectionIndex];

        if ($section) {
          return $section.offsetTop + 100;
        }

        return null;
      }

      connectedCallback() {
          this.addEventListener('click', this.itemClick);
      }

      disconnectedCallback() {
          this.removeEventListener('click', this.itemClick);
      }
      
      itemClick() {
        if (this.getAttribute('data-section-top') || this.sectionTop ) {
          window.scrollTo({
            top: this.getAttribute('data-section-top') || this.sectionTop,
            behavior: 'smooth',
          });
        }
      }
  }
  if (!window.customElements.get('yg-anchor')) {
      window.customElements.define('yg-anchor', YGAnchor)
  }

  class YGFScrollBanner extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      window.addEventListener('height-change', (e) => {
        this.initScrollAnimation();
      });
    }
  
    initScrollAnimation() {
      // 加载 gsap 和 ScrollTrigger
      if (!window.gsap || !window.ScrollTrigger) {
        const script1 = document.createElement('script');
        script1.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js';
        document.head.appendChild(script1);
  
        const script2 = document.createElement('script');
        script2.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js';
        script2.onload = () => this.registerAnimations();
        document.head.appendChild(script2);
      } else {
        this.registerAnimations();
      }
    }
  
    registerAnimations() {
      gsap.registerPlugin(ScrollTrigger);
  
      const section = this;
      const image = section.querySelector('.scroll-banner');
      const title = section.querySelector('.title-wrapper');

      ScrollTrigger.getAll()
      .filter(trigger => trigger.trigger === section || section.contains(trigger.trigger))
      .forEach(trigger => trigger.kill());
  
      // 图像淡入
      if (image) {
        gsap.set(image, { opacity: 0 });
        gsap.to(image, {
          scrollTrigger: {
            trigger: section,
            start: 'top top+=50%',
            end: 'top top-=220px',
            scrub: true,
          },
          opacity: 1
        });
      }
  
      // 标题淡出
      if (title) {
        gsap.to(title, {
          scrollTrigger: {
            trigger: section,
            start: 'top top+=120px',
            end: 'top top-=220px',
            scrub: true,
          },
          opacity: 0
        });
      }
    }
  }
  
  if (!customElements.get('yg-scroll-banner')) {
    customElements.define('yg-scroll-banner', YGFScrollBanner);
  }

  class YGScrollSwitch extends HTMLElement {
      constructor() {
          super()
      }

      get indicatorSwiper (){
        let indicator = this.querySelector('.yg-switch-indicator');

        return new Swiper(indicator, {
          slidesPerView: 'auto',
          noSwiping: true,
          direction: 'vertical',
        })
      }

      get swiper() {
        let swiper = this.querySelector('.yg-scroll-switch');

        return new Swiper(swiper, {
          slidesPerView: 1,
          spaceBetween: 0,
          noSwiping: true,
          direction: 'vertical',
          thumbs: {
            swiper: this.indicatorSwiper,
          }
        })
      }

      get titleBox() {
        return this.querySelectorAll('.yg-title-box')
      }

      connectedCallback() {
        this.swiper
        setTimeout(() => {
          this.registerAnimations()
        }, 4000)
      }

      registerAnimations() {
        gsap.registerPlugin(ScrollTrigger);
      
        const totalSlides = this.swiper.slides.length;
      
        gsap.to(this, {
          scrollTrigger: {
            trigger: this.querySelector('.yg-section-main'),
            start: "top top",
            end: `+=${200 * totalSlides}`,
            pin: true,
            scrub: 1,
            snap: 1 / (totalSlides - 1),
            onUpdate: (self) => {
              const index = Math.round(self.progress * (totalSlides - 1));
              this.swiper.slideTo(index, 400);
              if (index == 0) {
                this.swiper.setTranslate(index)
              }

              this.titleBox.forEach((title, i) => {
                title.style.transform = `translateX(${(index) * -100}%)`
              })
            },
          }
        });
      }
  }
  if (!window.customElements.get('yg-scroll-switch')) {
      window.customElements.define('yg-scroll-switch', YGScrollSwitch)
  }

  class YGBgSwiper extends HTMLElement {
      constructor() {
          super()
      }

      get swiper() {
        let swiper = this.querySelector('.yg-bg-swiper');

        return new Swiper(swiper, {
          breakpoints: { 
            320: {  //当屏幕宽度大于等于320
              slidesPerView: 1.1,
              spaceBetween: 16
            },
            550: {  //当屏幕宽度大于等于320
              slidesPerView: 2.2,
              spaceBetween: 24
            },
            980: {  //当屏幕宽度大于等于1280
              slidesPerView: 2.8,
              spaceBetween: 24
            }
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        })
      }

      connectedCallback() {
        window.addEventListener('height-change', (e) => {
      
          // 在这里调用你希望触发的函数
          this.initScrollAnimation();
        });
        
        this.swiper
      }
    
      initScrollAnimation() {
        // 加载 gsap 和 ScrollTrigger
        if (!window.gsap || !window.ScrollTrigger) {
          const script1 = document.createElement('script');
          script1.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js';
          document.head.appendChild(script1);
    
          const script2 = document.createElement('script');
          script2.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js';
          script2.onload = () => this.registerAnimations();
          document.head.appendChild(script2);
        } else {
          this.registerAnimations();
        }
      }
    
      registerAnimations() {
        gsap.registerPlugin(ScrollTrigger);
    
        const section = this;
        const image = section.querySelector('.yg-bg-image');
    
        // 图像淡入
        if (image) {
          gsap.set(image, { x: "100%" });
          gsap.to(image, {
            scrollTrigger: {
              trigger: section,
              start: 'top bottom',
              end: 'top top+=160px',
              scrub: true,
            },
            x: 0
          });
        }
  
      }
  }
  if (!window.customElements.get('yg-bg-swiper')) {
      window.customElements.define('yg-bg-swiper', YGBgSwiper)
  }

  class YGPartsList extends HTMLElement {
      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);

          this.$masterImages = null;
          this.$thumbnailImages = null
      }

      get masterImages() {
        if (!this.$masterImages) {
          this.$masterImages = this.querySelectorAll('.yg-master')
        }

        return this.$masterImages
      }

      get thumbnailImages() {
        if (!this.$thumbnailImages) {
          this.$thumbnailImages = this.querySelectorAll('.yg-thumbnail-item')
        }

        return this.$thumbnailImages
      }
      
      connectedCallback() {
        this.thumbnailImages.forEach((item, i) => {
          item.addEventListener('click',  (e) => this.itemClick(e, i));
        })
      }
      disconnectedCallback() {
        this.thumbnailImages.forEach((item, i) => {
          item.removeEventListener('click', (e) => this.itemClick(e, i));
        })
      }
      itemClick(e, i) {
        // 这里放置自定义逻辑
        this.thumbnailImages.forEach(($image) => {
          $image.classList.remove('active')
        })
        this.masterImages.forEach(($image) => {
          $image.classList.remove('active')
        })
        this.thumbnailImages[i].classList.add('active')
        this.masterImages[i].classList.add('active')
      }
  }
  if (!window.customElements.get('yg-parts-list')) {
      window.customElements.define('yg-parts-list', YGPartsList)
  }

  class YGScrollBer extends HTMLElement {
      constructor() {
          super()
          this.onScroll = this.onScroll.bind(this);

          this.scrollBer = this.querySelector('.scroll-thumb');
          this.scrollBox = this.scrollBer.parentElement.previousElementSibling;
      }
      connectedCallback() {
        this.scrollBox.addEventListener("scroll", this.onScroll);
        this.onScroll();
      }
      disconnectedCallback() {
        this.scrollBox.removeEventListener("scroll", this.onScroll);
      }

      onScroll() {
        const scrollTop = this.scrollBox.scrollTop;
        const scrollHeight = this.scrollBox.scrollHeight - this.scrollBox.clientHeight;
        const trackHeight = this.scrollBox.clientHeight;
        const thumbHeight = this.scrollBer.offsetHeight;
      
        const needsScroll = this.scrollBox.scrollHeight > trackHeight + 1;

        if (!needsScroll) {
          this.style.setProperty('--mask-start', '0px');
          this.style.setProperty('--mask-end', '0px');

          this.classList.add('no-scrollbar');
          return;
        }

        this.classList.remove('no-scrollbar');
        const moveRange = trackHeight - thumbHeight;
        const percent = scrollTop / scrollHeight;
      
        const translateY = moveRange * percent;
        this.scrollBer.style.transform = `translateY(${translateY}px)`;

        const isAtTop = scrollTop === 0;
        const isAtBottom = scrollTop + trackHeight >=  this.scrollBox.scrollHeight - 1; // 容错

        if (isAtTop) {
          this.style.setProperty('--mask-start', '0px');
          this.style.setProperty('--mask-end', '50px');
        } else if (isAtBottom) {
          this.style.setProperty('--mask-start', '50px');
          this.style.setProperty('--mask-end', '0px');
        } else {
          this.style.setProperty('--mask-start', '50px');
          this.style.setProperty('--mask-end', '50px');
        }
      }
  }
  if (!window.customElements.get('yg-scroll-ber')) {
      window.customElements.define('yg-scroll-ber', YGScrollBer)
  }

  class YGScrollVideo extends HTMLElement {
      constructor() {
          super()

          this.main = this.querySelector('.yg-video-box')
          this.image = this.querySelector('.yg-mask-image')
          this.video = this.querySelector('.yg-video')
      }

      connectedCallback() {
        setTimeout(() => {
          this.registerAnimations()
        }, 4000)
      }

      registerAnimations() {
        console.log(this.main)
        gsap.registerPlugin(ScrollTrigger);

        gsap.set(this.image, { scale: 1.4 });
        gsap.set(this.video, { scale: 1.4 });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: this.main,
            start: "top top",
            end: "+=1500px",
            scrub: 1,
            pin: true,
          }
        });
        
        tl.to(this.image, { scale: 0.5 }, 0);
        tl.to(this.video, { scale: 0.5 }, 0);
      }
  }
  if (!window.customElements.get('yg-scroll-video')) {
      window.customElements.define('yg-scroll-video', YGScrollVideo)
  }

  class YGScrollImage extends HTMLElement {
    constructor() {
        super()

        this.main = this.querySelector('.yg-video-box')
        this.image = this.querySelector('.yg-mask-image')
    }

    connectedCallback() {
      setTimeout(() => {
        this.registerAnimations()
      }, 4000)
    }

    registerAnimations() {
      gsap.registerPlugin(ScrollTrigger);

      gsap.set(this.image, { scale: 1});

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.main,
          start: "top top",
          end: "+=1500px",
          scrub: 1,
          pin: true,
        }
      });
      
      tl.to(this.image, {
        scale: 2.5,
        opacity: 1
      }, 0);
    
      // 第二段：scale 2.5 -> 5，opacity 1 -> 0
      tl.to(this.image, {
        scale: 5,
        opacity: 0
      });
    }
  }
  if (!window.customElements.get('yg-scroll-image')) {
      window.customElements.define('yg-scroll-image', YGScrollImage)
  }

  class YGHotVideo extends HTMLElement {
      constructor() {
          super()
      }
      connectedCallback() {
        this.initSwiper()
      }

      initSwiper() {
        // 这里放置自定义逻辑
        new Swiper(this, {
          centeredSlides: true,
          slidesPerView: 'auto',
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: { 
            320: {  //当屏幕宽度大于等于320
              slidesPerView: 1,
              spaceBetween: 16
            },
            768: {  //当屏幕宽度大于等于320
              slidesPerView: 1.1,
              spaceBetween: 24
            },
            1280: {  //当屏幕宽度大于等于1280
              slidesPerView: 1.3,
              spaceBetween: 40
            }
          },
          on:{
            init: e => {
              if (e.passedParams.loop && e.slides.length < 4) {
                e.slides.forEach(slide => {
                  const clonedElement = slide.cloneNode(true);
                  e.slidesEl.appendChild(clonedElement);
                });
              }
            }
          }
        })
      }
  }
  if (!window.customElements.get('yg-hot-video')) {
      window.customElements.define('yg-hot-video', YGHotVideo)
  }

  class YGVideoGuide extends HTMLElement {
      constructor() {
          super()
          this.$tabList = this.querySelectorAll('.yg-guide-tab')
          this.$tabContentList = this.querySelectorAll('.yg-guide-content')
          this.itemClick = this.itemClick.bind(this);
      }
      
      connectedCallback() {
        this.initSwiper()
        this.$tabList.forEach(($tab, i) => {
          $tab.addEventListener('click', (e)=>this.itemClick($tab, i));
        })
      }
      disconnectedCallback() {
        this.$tabList.forEach(($tab, i) => {
          $tab.removeEventListener('click', (e)=>this.itemClick($tab, i));
        })
      }

      initSwiper() {
        let $swiperList = this.querySelectorAll(".swiper")

        $swiperList.forEach((swiperItem) => {
          new Swiper(swiperItem, {
            scrollbar: {
              el: '.swiper-scrollbar'
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              320: {  //当屏幕宽度大于等于320
                slidesPerView: 1.1,
                spaceBetween: 12
              },
              768: {  //当屏幕宽度大于等于320
                slidesPerView: 2,
                spaceBetween: 24
              },
              1280: {  //当屏幕宽度大于等于1280
                slidesPerView: 3,
                spaceBetween: 24
              }
            }
          })
        })
      }

      itemClick($tab, i) {
        if ($tab.classList.contains('active')) return

        this.$tabList.forEach(($tab) => {
          $tab.classList.remove('active')
        })
        this.$tabContentList.forEach(($tabContentList) => {
          $tabContentList.classList.remove('active')
        })
        this.$tabList[i].classList.add('active')
        this.$tabContentList[i].classList.add('active')
      }
  }
  if (!window.customElements.get('yg-video-guide')) {
      window.customElements.define('yg-video-guide', YGVideoGuide)
  }

  class YG3DList extends HTMLElement {
      constructor() {
          super()
      }
      connectedCallback() {
        this.initSwiper()
      }

      initSwiper() {
          new Swiper(this, {
            scrollbar: {
              el: '.swiper-scrollbar'
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              320: {  //当屏幕宽度大于等于320
                slidesPerView: 1.1,
                spaceBetween: 12
              },
              768: {  //当屏幕宽度大于等于320
                slidesPerView: 2,
                spaceBetween: 24
              },
              1280: {  //当屏幕宽度大于等于1280
                slidesPerView: 3,
                spaceBetween: 24
              }
            }
          })
      }
  }
  if (!window.customElements.get('yg-3d-list')) {
      window.customElements.define('yg-3d-list', YG3DList)
  }

  class YGNavAnchor extends HTMLElement {
    constructor() {
      super();
      this.sections = [];
      this.anchors = [];
      this.anchorIndexes = [];
      this.currentActive = null;
      this._scrolling = false;
      this._onResize = this.updateSectionPositions.bind(this);
      this.handleScroll = this.handleScroll.bind(this);
    }
  
    connectedCallback() {
      this.anchors = Array.from(this.querySelectorAll('.yg-nav-anchor__item'));
  
      // 提取并排序 anchors
      this.anchorIndexes = this.anchors
        .map(anchor => parseInt(anchor.dataset.section))
        .sort((a, b) => a - b);
  
      // 初始化 section 引用并设置编号
      const rawSections = Array.from(document.querySelectorAll('.main-content .shopify-section'));
  
      rawSections.forEach((section, i) => {
        section.setAttribute('data-section-number', i);
      });
  
      this.rawSections = rawSections;
      this.updateSectionPositions(); // 首次定位
  
      // 滚动和 resize 监听
      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this._onResize);
      this.handleScroll(); // 初始化一次
    }
  
    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this._onResize);
    }
  
    updateSectionPositions() {
      this.sections = this.rawSections.map(el => ({
        el,
        index: parseInt(el.dataset.sectionNumber),
        top: el.getBoundingClientRect().top + window.scrollY
      }));
    }
  
    handleScroll() {
      if (this._scrolling) return;
      this._scrolling = true;
  
      requestAnimationFrame(() => {
        const scrollMiddle = window.scrollY + window.innerHeight / 2;
        let currentIndex = null;
  
        for (let section of this.sections) {
          const height = section.el.offsetHeight;
          if (scrollMiddle >= section.top && scrollMiddle < section.top + height) {
            currentIndex = section.index;
            break;
          }
        }
  
        if (currentIndex === null) {
          this._scrolling = false;
          return;
        }
  
        // 区间匹配
        let anchorToHighlight = null;
        for (let i = 0; i < this.anchorIndexes.length - 1; i++) {
          const from = this.anchorIndexes[i];
          const to = this.anchorIndexes[i + 1];
          if (currentIndex >= from && currentIndex < to) {
            anchorToHighlight = from;
            break;
          }
        }
  
        if (currentIndex >= this.anchorIndexes[this.anchorIndexes.length - 1]) {
          anchorToHighlight = this.anchorIndexes[this.anchorIndexes.length - 1];
        }
  
        if (anchorToHighlight !== this.currentActive) {
          this.setActive(anchorToHighlight);
        }
  
        this._scrolling = false;
      });
    }
  
    setActive(index) {
      this.anchors.forEach(anchor => {
        anchor.classList.toggle('active', parseInt(anchor.dataset.section) === index);
      });
      this.currentActive = index;
    }
  }
  
  if (!window.customElements.get('yg-nav-anchor')) {
    window.customElements.define('yg-nav-anchor', YGNavAnchor);
  }

  class YGCollectionTab extends HTMLElement {
    constructor() {
      super()
      this.$tabList = this.querySelectorAll('.yg-tab')
      this.$tabContentList = this.querySelectorAll('.yg-content')
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.$tabList.forEach(($tab, i) => {
        $tab.addEventListener('click', (e)=>this.itemClick($tab, i));
      })
    }
    disconnectedCallback() {
      this.$tabList.forEach(($tab, i) => {
        $tab.removeEventListener('click', (e)=>this.itemClick($tab, i));
      })
    }

    itemClick($tab, i) {
      if ($tab.classList.contains('active')) return

      this.$tabList.forEach(($tab) => {
        $tab.classList.remove('active')
      })
      this.$tabContentList.forEach(($tabContentList) => {
        $tabContentList.classList.remove('active')
      })
      this.$tabList[i].classList.add('active')
      this.$tabContentList[i].classList.add('active')
    }
  }
  if (!window.customElements.get('yg-collection-tab')) {
      window.customElements.define('yg-collection-tab', YGCollectionTab)
  }

  class YGPullDown extends HTMLElement {
    constructor() {
        super()
        this.itemClick = this.itemClick.bind(this);
        this.height = this.getAttribute('data-height')
        this.$targetElement = this.previousElementSibling
    }
    connectedCallback() {
        this.isPull()
        this.addEventListener('click', this.itemClick);
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);
    }
    itemClick() {
      // 这里放置自定义逻辑
      if(!this.classList.contains('active')) {
        let height = 0;
        this.$targetElement.style.height = "auto"
        height = this.$targetElement.getBoundingClientRect().height
        this.$targetElement.style.height = this.height + 'px'
        this.$targetElement.getBoundingClientRect().height
        this.$targetElement.style.height = height + 'px'
        this.classList.add('active')
        this.$targetElement.classList.add('active')
      } else {
        this.$targetElement.style.height = this.height + 'px'
        this.classList.remove('active')
        this.$targetElement.classList.remove('active')
      }
    }
    isPull(){
      if (this.$targetElement.offsetHeight <= this.height) {
        this.remove()
      } else {
        this.$targetElement.classList.add('yg-pull-main')
        this.$targetElement.style.height = this.height + 'px'
      }
    }
  }
  if (!window.customElements.get('yg-pull-down')) {
      window.customElements.define('yg-pull-down', YGPullDown)
  } 
})  